import { render, staticRenderFns } from "./ArrematanteInput.vue?vue&type=template&id=097eb1d0&scoped=true"
import script from "./ArrematanteInput.vue?vue&type=script&lang=js"
export * from "./ArrematanteInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097eb1d0",
  null
  
)

export default component.exports